import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProjectionForLocationModeComponent } from './projection-for-location-mode.shared.component';

@NgModule({
    declarations: [
        ProjectionForLocationModeComponent
    ],
    imports: [CommonModule],
    exports: [
        ProjectionForLocationModeComponent
    ],
    providers: [],
})
export class ProjectionForLocationModeModule { }
